import Phaser from 'phaser';
import { Colors } from '../consts/Colors.js';
import { Sizes } from '../consts/Sizes.js';

export default class MissionTitle extends Phaser.GameObjects.Container {
    constructor(scene, x, y, missionNumber, missionName, title, description, ratio) {
        super(scene, x, y);

        // ---------------------
        // Eléments de MissionTitle
        // ---------------------

        // 🟦 titleBack + titleText
        this.titleBack = this.scene.add
            .rexRoundRectangle(0, -10, 346, 68 * 2, 12, 0xffffff)
            .setOrigin(0.5)
            .setAlpha(0);

        this.titleText = this.scene.add
            .text(0, -10, title.toUpperCase(), {
                fontSize: `128px`,
                fontFamily: 'WWF',
                color: Colors.Text.DarkBlue,
            })
            .setOrigin(0.5)
            .setAlpha(0);

        this.titleBack.setDisplaySize(
            this.titleText.width * 1.5 * ratio,
            this.titleText.height * 1.8 * ratio
        );

        // ✅ Ajuster après création
        const paddingTitleX = 20 * ratio;
        const paddingTitleY = 10 * ratio;

        const titleBackWidth = this.titleText.width + paddingTitleX * 2.8;
        const titleBackHeight = this.titleText.height + paddingTitleY * 2;

        this.titleBack.setSize(titleBackWidth, titleBackHeight);

        // 🟣 badge + badgeText
        this.badge = this.scene.add
            .rexRoundRectangle(0, -110, 100, 60, 32, Colors.Elmt.BleuNovotel) // taille temporaire
            .setOrigin(0.5)
            .setAngle(-2)
            .setAlpha(0);

        this.badgeText = this.scene.add
            .text(0, -110, `${missionName} N°${missionNumber}`, {
                fontSize: '32px',
                fontFamily: 'Binx',
                color: Colors.Text.White,
            })
            .setOrigin(0.5)
            .setAngle(-2)
            .setAlpha(0);

        // ✅ Ajuster après création
        const paddingX = 10 * ratio;
        const paddingY = 0 * ratio;

        const badgeWidth = this.badgeText.width + paddingX * 2;
        const badgeHeight = this.badgeText.height + paddingY * 2;

        this.badge.setSize(badgeWidth, badgeHeight);

        // 📝 descriptionText
        this.descriptionText = this.scene.add
            .text(0, 150, description, {
                fontSize: Sizes.Text.h3,
                fontFamily: 'MonteserratMedium',
                color: Colors.Text.White,
                wordWrap: { width: 372 * ratio },
                align: 'center',
            })
            .setOrigin(0.5)
            .setLineSpacing(8)
            .setAlpha(0);

        // ✅ Add all
        this.add([
            this.titleBack,
            this.titleText,
            this.badge,
            this.badgeText,
            this.descriptionText,
        ]);

        scene.add.existing(this);
    }

    animateIn() {
        // 1️⃣ titleBack + titleText
        this.scene.tweens.add({
            targets: [this.titleBack, this.titleText],
            alpha: 1,
            scale: { from: 0, to: 1 },
            duration: 400,
            ease: 'Back.easeOut',
            onComplete: () => {
                // 2️⃣ badge + badgeText
                this.scene.tweens.add({
                    targets: [this.badge, this.badgeText],
                    alpha: 1,
                    scale: { from: 0, to: 1 },
                    duration: 400,
                    ease: 'Back.easeOut',
                    onComplete: () => {
                        // 3️⃣ descriptionText
                        this.scene.tweens.add({
                            targets: this.descriptionText,
                            alpha: 1,
                            scale: { from: 0, to: 1 },
                            duration: 400,
                            ease: 'Back.easeOut',
                        });
                    },
                });
            },
        });
    }
}
